var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#005A9C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.93,56.28c-0.77,0-1.49-0.51-1.7-1.3c-0.23-0.93,0.3-1.89,1.23-2.14C46.91,50.34,53.49,41.78,53.49,32 c0-11.87-9.65-21.53-21.51-21.53c-10.07,0-16.67,5.89-19.77,9.45h6.84c0.95,0,1.74,0.79,1.74,1.75s-0.74,1.77-1.72,1.77H8.77 c-0.16,0-0.33-0.02-0.49-0.07c-0.21-0.07-0.4-0.16-0.56-0.28c-0.21-0.14-0.37-0.33-0.49-0.54C7.12,22.32,7.02,22.08,7,21.83 c0-0.07,0-0.12,0-0.19V11.07c0-0.95,0.79-1.75,1.74-1.75s1.74,0.79,1.74,1.75v5.56C14.28,12.56,21.42,7,32,7 c13.79,0,25,11.22,25,25.02c0,11.36-7.65,21.32-18.63,24.21C38.23,56.26,38.07,56.28,37.93,56.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.35,57c-0.05,0-0.12,0-0.16-0.02c-2.49-0.16-4.93-0.72-7.26-1.63c-0.67-0.26-1.12-0.93-1.12-1.65 c0-0.21,0.05-0.42,0.12-0.61c0.35-0.88,1.37-1.35,2.26-1c2,0.79,4.12,1.26,6.26,1.42h0.02c0.93,0.05,1.63,0.84,1.63,1.77 c0,0.02,0,0.07,0,0.09C32.02,56.28,31.26,57,30.35,57z M17.53,52c-0.4,0-0.77-0.12-1.09-0.37c-1.95-1.56-3.65-3.4-5.07-5.47 c-0.21-0.3-0.33-0.63-0.33-0.98c0-0.58,0.28-1.12,0.77-1.44c0.77-0.54,1.91-0.33,2.42,0.44c1.23,1.79,2.7,3.38,4.4,4.7 c0.4,0.33,0.65,0.81,0.65,1.35c0,0.4-0.12,0.79-0.37,1.12C18.58,51.76,18.07,52,17.53,52z M9.77,40.64 c-0.77,0-1.44-0.49-1.65-1.21C7.37,37.03,7,34.54,7,32.02c0-0.95,0.79-1.75,1.74-1.75s1.74,0.79,1.74,1.75 c0,2.16,0.33,4.31,0.95,6.35c0.05,0.16,0.07,0.35,0.07,0.54c0,0.77-0.49,1.42-1.21,1.65C10.12,40.61,9.95,40.64,9.77,40.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 32,
    cy: 32.02,
    rx: 9.3,
    ry: 9.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.7a52b9b39727cd4a2f9b46b3394002c0.svg";
export { ForwardRef as ReactComponent };